export const resolveThemeMode = (
  enableDarkModeSignup: boolean | undefined,
  appMode: string | undefined,
  forcedThemeModeEnrollment: string | undefined
): 'light' | 'dark' => {
  if (!enableDarkModeSignup) {
    return 'light'
  }

  if (forcedThemeModeEnrollment && forcedThemeModeEnrollment !== 'none') {
    return forcedThemeModeEnrollment as 'light' | 'dark'
  }

  if (appMode === 'dark') {
    return 'dark'
  }

  return 'light'
}
